import { Injectable } from '@angular/core';
import dayjs from 'dayjs';

import { AccountCenterAgency } from '../../models/account-center-agency.model';
import { AgencyModel } from '../../models/agency.model';

@Injectable({
  providedIn: 'root',
})
export class HelpChoicesService {
  private dayjs = dayjs;

  /**
   * Returns true when agency has a paid feature and is not on trial
   */
  public canAccessChat(agency: AgencyModel): boolean {
    return agency?.hasFeature('lc_chat') && this.paid(agency);
  }

  /**
   * Returns true if an agency is in a free trial or on a plan higher than Lite
   */
  public canSubmitTicket(agency: AgencyModel): boolean {
    if (agency?.trial) {
      return true;
    }
    return this.paid(agency) && agency?.hasFeature('support_ticket');
  }

  public allowDemoVideo(agency: AgencyModel): boolean {
    return !agency?.hipaa;
  }

  public showDemo(agency: AgencyModel | AccountCenterAgency): boolean {
    if (!agency) {
      return false;
    }
    return this.dayjs().diff(agency.created_at, 'days') <= 90;
  }

  private paid(agency: AgencyModel): boolean {
    if (agency?.trial) {
      return false;
    }
    return agency?.hasFeature('paid_forms') || agency?.calls_enabled;
  }
}
